module dg.objects {

    export class ObjectService {

        private templateNames: string[] = ['severity-level', 'flight-leg-readout-status', 'raw-file-status', 'analysis-status', 'analysedobjects', 'integration-response-status'];

        public constructor() {

        }

        public templateExists(templateName) : boolean {
            return this.templateNames.indexOf(templateName) > -1;
        }

    }

    angular.module('dg.objects')
        .service('objectService', ObjectService);
}